export enum AccountSubscription {
  Monthly = 'monthly',
  Annual = 'annual',
  Pro = 'pro',
  Select = 'select',
  Enterprise = 'enterprise',
}
